import { Grid, Typography } from '@material-ui/core';
import { FuncaoParticipante, ParticipanteResponse, CodigoInstumentoResponse } from 'common/genericTypes';
import { MdSpace, TextField, Dropdown } from 'm2m.components';
import React, { useCallback, useEffect, useState } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import { updateId, updateCodigoExterno, updateCodigoInstrumento } from 'store/modules/notaComercial/emissor';
import { labelsEmissor as labels } from '../labels';

const mapStateToProps = (state: RootState) => ({
  emissorId: state.notaComercialCadastro.emissor.id,
  codigoExterno: state.notaComercialCadastro.emissor.codigoExterno,
  codigoInstrumento: state.notaComercialCadastro.emissor.codigoInstrumento,
  participanteApi: state.participanteApi,
});

const mapDispatchToProps = { updateId, updateCodigoExterno, updateCodigoInstrumento };
type Props = ReturnType<typeof mapStateToProps> & typeof mapDispatchToProps;

const ValidacapEmissor: React.FC<Props> = (props) => {
  const dispatch = useDispatch();
  const {
    updateId,
    updateCodigoExterno,
    updateCodigoInstrumento,
    emissorId,
    codigoInstrumento,
    codigoExterno,
    participanteApi: { getParticipantes },
  } = props;

  const [emissores, setEmissores] = useState<Array<ParticipanteResponse>>([]);
  const [codigos, setCodigos] = useState<Array<CodigoInstumentoResponse>>([]);
  const getNotasComerciaisByEmissorCnpj = useSelector((state: RootState) => state.notaComercialApi.getNotasComerciaisByEmissorCnpj)
  const getParticipantesResume = useSelector((state: RootState) => state.participanteApi.getParticipantesResume)

  const getEmissores = useCallback(async () => {
    try {
      const result = await getParticipantesResume(dispatch, { funcao: FuncaoParticipante.Emissor, suspenso: false });
      setEmissores(result);
    } catch (error) {}
  }, [dispatch, getParticipantesResume]);

  const getInstrumento = useCallback( async () => {
    const emissor = emissores.find(em => em.id == emissorId);
    if(emissor != null) {
      const codigosIF = await getNotasComerciaisByEmissorCnpj(dispatch, emissor.cnpj); 
      setCodigos(codigosIF);
    }
  },[dispatch, emissorId])

  useEffect(() => {
    getEmissores();
    getInstrumento();
  }, [getEmissores, getInstrumento]);

  return (
    <>
      <Grid container justify="center">
        <Grid item sm={4}>
          <Typography variant="h3" align="center">
            {'Antes de começar, nos informe o Emissor e o código da Nota Comercial a ser cadastrada:'}
          </Typography>
          <MdSpace />
          <Dropdown
            label={labels.emissor}
            onChange={(value) => updateId(value)}
            options={emissores.map((emissor) => {
              return { description: emissor.razaoSocial, value: emissor.id };
            })}
            required
            value={emissorId}
          />
          <MdSpace />
          <TextField
            label={labels.codigoExterno}
            value={codigoExterno}
            onChange={(value) => updateCodigoExterno(value)}
            required
          />
          <MdSpace />
          { codigos.length > 0 &&
            <Dropdown
              label={labels.codigoInstrumento} 
              value={codigoInstrumento}
              onChange={(value) => updateCodigoInstrumento(value)} 
              options={codigos.map((codigo:CodigoInstumentoResponse) => {
                return { description: codigo.codigo, value: codigo.codigo };
              })}
              required
          />
          }
          <MdSpace />
        </Grid>
      </Grid>
    </>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(ValidacapEmissor);
